import { render } from "./LoadingMessage.vue?vue&type=template&id=6be7dc1a"
import script from "./LoadingMessage.vue?vue&type=script&lang=js"
export * from "./LoadingMessage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__